import { useSMSWebsocket, useMessagesWebsocketFirm } from 'providers/WebsocketProvider/hooks';

interface WebsocketLauncherProps {
  authToken: string;
}

export default function WebsocketLauncher({
  authToken,
}: WebsocketLauncherProps) {
  useSMSWebsocket(authToken);
  useMessagesWebsocketFirm(authToken);

  return null;
}
